<!--
 * @Author: 月魂
 * @Date: 2021-12-02 18:53:25
 * @LastEditTime: 2021-12-06 11:21:24
 * @LastEditors: 月魂
 * @Description: 日程页面
 * @FilePath: \seven-silk\src\views\ScheduleList.vue
-->
<template>
  <div class="box">
    <img src="../assets/back.png" alt="" class="back" @click="() => this.$router.go(-1)">
    <img src="../assets/table.png" alt="" class="table">
  </div>
</template>

<script>
export default {
  name: 'ScheduleList'
}
</script>

<style lang="less" scoped>
.box {
  min-height: 100%;
  background-color: #eb8f27;
  color: #fff;
  position: relative;
  padding-top: 40px;
  .back {
    display: block;
    position: absolute;
    top: 16px;
    left: 10px;
    width: 24PX;
  }
  .table {
    display: block;
    width: 100%;
  }
}
</style>
